/* eslint-disable no-undef */
import config from "./configure.json";
export default config[process.env.REACT_APP_ENV];
console.log("process.env.REACT_ENV: ", process.env.REACT_APP_ENV);
